import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonsWrapper: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      maxWidth: 240,
      alignItems: 'center',
      [theme.breakpoints.up('lg')]: {
        flexDirection: 'row',
        alignItems: 'flex-end',
        maxWidth: 'unset',
        justifyContent: 'flex-end',
      },
      [theme.breakpoints.down('md')]: {
        margin: '0 auto',
      },
    },
    button: {
      flex: 1,
      marginBottom: SMALL_MARGIN,
      width: '100%',
      [theme.breakpoints.up('lg')]: {
        flex: 'unset',
        marginBottom: 0,
        marginRight: SMALL_MARGIN,
        width: 'unset',
        '&:last-child': {
          marginRight: 0,
        },
      },
      '&:last-child': {
        marginBottom: 0,
      },
      '&:hover': {
        '& $linkedInIcon': {
          '& path': {
            fill: 'rgba(0, 0, 0, 0.87) !important',
          },
        },
        '& $shareIcon, & $buttonIcon': {
          color: 'rgba(0, 0, 0, 0.87)',
        },
      },
    },
    buttonIcon: {
      width: 14,
      height: 14,
      marginRight: 9,
    },
    shareButton: {
      padding: '13px 13px',
      minWidth: 'unset',
    },
    shareIcon: {
      width: 14,
      height: 14,
    },
    linkedInIcon: {},
  }),
);

export default useStyles;
